import React from "react";
import { ModalContent, ModalWrapper } from "./styled";

interface ModalProps {
  isOpen: boolean;
  children: React.ReactNode;
}

const Modal = ({ isOpen, children }: ModalProps) => {
  if (!isOpen) return null;

  return (
    <>
      <ModalWrapper>
        <ModalContent>{children}</ModalContent>
      </ModalWrapper>
    </>
  );
};

export default Modal;
